/// <reference path="../../../../typings/index.d.ts" />
/// <reference path="miscSupplyDefinitions.module.ts" />

module Meevo.Plugins.MiscSupplyDefinitions {

    import ObjectStateEnum = Meevo.Model.ObjectStateEnum;

    class MiscSupplyDefinitionsController extends Meevo.Components.BaseClasses.DataMaintenanceControllerBase {

        static $inject = [
            'meevo.AppSettings',
            'meevo.components.common.DataService',
            'meevo.components.modal.ModalService',
            'meevo.components.common.IdentityService',
            'meevo.components.logging.LoggingService',
            'meevo.components.common.SecurityService',
            'meevo.components.tracking.TrackingService',
            '$rootScope',
            '$scope',
            '$state',
            'meevo.ContextParams',
            'meevo.components.short-cuts.ShortCutsService',

            'meevo.components.busy.BusyService',
            '$translate',
            '$timeout'];

        constructor(protected appSettings: Meevo.Components.Common.IAppSettings,
            protected dataService: Meevo.Components.BaseClasses.IDataService,
            protected modalService: Meevo.Components.Modal.IModalService,
            protected identityService: Meevo.Components.Common.IIdentityService,
            protected loggingService: Meevo.Components.Logging.ILoggingService,
            protected securityService: Meevo.Components.Common.ISecurityService,
            protected trackingService: Meevo.Components.Tracking.ITrackingService,
            protected $rootScope: angular.IRootScopeService,
            protected $scope: angular.IScope,
            protected $state: any,
            protected contextParams: Meevo.IContextParams,
            protected shortCutsService: Meevo.Components.ShortCuts.IShortCutsService,

            protected busyService: Meevo.Components.Busy.IBusyService,
            protected $translate: angular.translate.ITranslateService,
            protected $timeout: angular.ITimeoutService) {

            super(appSettings, dataService, modalService, identityService, loggingService, $scope, contextParams, $state, $rootScope, shortCutsService);

        }

        /**
       * Creates the context for editing/adding an item.
       */
        createContext(): void {
            this.busyService.start();
            this.securityService.checkSection(this.meevoSecurityKeys.INVENTORY_MISCSUPPLYDEFINITIONS).then(() => {
                this.busyService.stop();
                this.context = new MiscSupplyDefinitionsContext(this.appSettings, this.dataService, this.modalService, this.identityService, this.loggingService, this.securityService, this.trackingService, this.$timeout);
                this.context.activate(this.selectedItemId, null, this.asLocationId);
                this.context.deactivate = () => {
                    this.visualState = Model.MaintenanceFormVisualState.Search;
                };
                // Use translate service to populate field list
                this.context.locationFieldList =
                    [
                        { field: 'ObjectState', label: this.$translate.instant('HEADER_STATUS'), checked: false },
                    ];
            }).catch(() => {
                this.busyService.stop();
            });
        }

        preSearchCallback(criteria, rootCriteria): void {
            rootCriteria.isMiscellaneous = 1;
            rootCriteria.includeNotForSale = 1;
            rootCriteria.supplyCategory = criteria.supplyCategory;

            criteria.isMiscellaneous = 1;
            criteria.IncludeBundles = 0;
            criteria.NotForSale = 1;
            criteria.variantObjectState = [];


            if (!criteria.includeActive && !criteria.includeDeleted) {
                criteria.includeActive = true;
            }

            criteria.distributorId = (criteria.distributor && criteria.distributor.id) ? criteria.distributor.id : null;

            if (criteria.includeActive) {
                criteria.variantObjectState.push(ObjectStateEnum.Active); // = [2026, 2027];
            }
            if (criteria.includeDiscontinued) {
                criteria.variantObjectState.push(ObjectStateEnum.Inactive); // = [2026, 2027];
            }
            if (criteria.includeDeleted) {
                criteria.variantObjectState.push(ObjectStateEnum.Deleted);
            }
        }
    }

    angular.module('meevo.plugins.miscSupplyDefinitions')
        .controller('meevo.plugins.miscSupplyDefinitions.MiscSupplyDefinitionsController', MiscSupplyDefinitionsController);
}
